import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getImports: {
        method: 'GET',
        url: `${BASE_PATH_API}/imports`,
        params: {
            '$count': true
        }
    },
    getImportTypes: {
        method: 'GET',
        url: `${BASE_PATH_API}/imports/types`
    },
    createUpload: {
        method: 'POST',
        url: `${BASE_PATH_API}/imports`
    },
    createImport: {
        method: 'POST',
        url: `${BASE_PATH_API}/imports/:id`
    },
    deleteImport: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/imports/:id`
    },
    deletePendingImports: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/imports/pending`
    },
    uploadSettingsPermission: {
        method: 'GET',
        url: `${BASE_PATH_API}/imports/uploadSettingsPermission/:id`
    },
    getSampleTemplate: {
        method: 'GET',
        url: `${BASE_PATH_API}/imports/sampleTemplate?importTypeId=:templateId`,
        responseType: 'blob',
        transformResponse: function transformResponse(response, headers) {
            const contentDisposition = headers.get('content-disposition')
                ? headers.get('content-disposition').split('filename=')
                : [];

            return {
                data: response,
                filename: contentDisposition && contentDisposition.length > 1
                    ? contentDisposition[contentDisposition.length - 1]
                    : null
            };
        }
    },
    getCustomTemplate: {
        method: 'GET',
        url: `${BASE_PATH_API}/imports/customTemplate?importTypeId=:templateId`,
        responseType: 'blob',
        transformResponse: function transformResponse(response, headers) {
            const contentDisposition = headers.get('content-disposition')
                ? headers.get('content-disposition').split('filename=')
                : [];

            return {
                data: response,
                filename: contentDisposition && contentDisposition.length > 1
                    ? contentDisposition[contentDisposition.length - 1]
                    : null
            };
        }
    }
};

export function ImportsApi() {
    return createActions(actions);
}
